import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { applyDocumentLanguage } from "./i18n/index.js";
import { initAnalytics } from "./lib/analytics.js";
import { createAppRouter } from "./router.jsx";
import { ThemeProvider } from "./theme/index.js";
import "./ui/components.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element #root not found");
}

// Resolve the language before the first paint so `<html lang>` and the first
// rendered strings agree. The router keeps them in sync after that.
applyDocumentLanguage();
initAnalytics();

createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <RouterProvider router={createAppRouter()} />
    </ThemeProvider>
  </StrictMode>,
);
